import { useSeo } from '../../lib/seo';

export default function PrivacyPage() {
  useSeo({
    title: 'プライバシーポリシー | 合同会社WakuWaku',
    description: '合同会社WakuWakuのAI業務支援システムにおける、Googleサービス連携情報の取り扱いについて。',
    path: '/privacy/',
    noindex: true,
  });

  return (
    <main className="min-h-screen bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-16 md:py-24">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
          プライバシーポリシー
        </h1>

        <div className="space-y-8 text-gray-700 leading-relaxed text-sm md:text-base">
          <p>
            合同会社WakuWaku（以下「当社」）は、社内業務効率化のために独自に開発したAI業務支援システム（以下「本システム」）を運用しています。本システムがGoogleサービス（Gmail、カレンダー、ドライブ、タスク）と連携する際に取得・利用する情報について、以下の通りお知らせします。
          </p>

          <section>
            <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
              取得する情報
            </h2>
            <p className="mb-3">
              本システムは、Googleアカウントの認証を通じて、以下の情報にアクセスします。
            </p>
            <ul className="space-y-2 list-none">
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1">・</span>
                Gmailのメール内容の読み取り・送信
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1">・</span>
                Googleカレンダーの予定の閲覧・作成・編集
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1">・</span>
                Googleドライブのファイルへのアクセス
              </li>
              <li className="flex items-start gap-2">
                <span className="text-gray-400 mt-1">・</span>
                Googleタスクの閲覧・完了操作
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
              利用目的
            </h2>
            <p>
              取得した情報は、当社内部の業務効率化（メール確認、スケジュール管理、タスク管理、資料管理）のためにのみ利用します。
            </p>
          </section>

          <section>
            <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
              第三者提供
            </h2>
            <p>
              取得した情報を第三者に提供・販売することはありません。
            </p>
          </section>

          <section>
            <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
              お問い合わせ
            </h2>
            <p className="mb-2">
              本ポリシーに関するお問い合わせは下記までご連絡ください。
            </p>
            <p className="font-medium">合同会社WakuWaku</p>
            <p>waku-w.company@waku-waku.biz</p>
          </section>

          <p className="text-gray-500 text-sm pt-4">
            制定日：2026年9月18日
          </p>
        </div>
      </div>
    </main>
  );
}